<div class="text-module-container" [ngClass]="{'theme-dark': isDarkMode}">
  <div class="academic-accent"></div>
  <mat-toolbar color="primary" class="text-module-header">
    <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span>AI Assistant</span>
    <span class="spacer"></span>
    <button mat-icon-button [matTooltip]="'Help'" (click)="openTextModuleGuide()">
      <mat-icon>help_outline</mat-icon>
    </button>
    <button mat-icon-button [matTooltip]="isDarkMode ? 'Light Mode' : 'Dark Mode'" (click)="toggleDarkMode()">
      <mat-icon>{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
    <button mat-icon-button [matTooltip]="'Clear History'" (click)="clearHistory()">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-toolbar>

  <!-- Global Loader -->
  <div class="global-loader" *ngIf="isGenerating">
    <div class="loader-content">
      <div class="spinner-container">
        <svg class="spinner">
          <use xlink:href="assets/icons/text-module-sprites.svg#spinner"></use>
        </svg>
      </div>
      <div class="loader-text">
        <h3>
          <!-- Temporarily hiding academic content generator
          <ng-container *ngIf="activeInterface === 'academic'">Generating Academic Content</ng-container>
          -->
          <ng-container *ngIf="activeInterface === 'document'">Processing Your Request</ng-container>
          <ng-container *ngIf="activeInterface === 'direct'">Processing Your Request</ng-container>
        </h3>
        <p>
          <!-- Temporarily hiding academic content generator
          <ng-container *ngIf="activeInterface === 'academic' && academicForm.get('contentType')?.value">
            Creating {{ getContentTypeLabel(academicForm.get('contentType')?.value) }} 
            on "<strong>{{ academicForm.get('topic')?.value }}</strong>"
            <ng-container *ngIf="selectedFocusAreas.length > 0">
              with focus on <strong>{{ selectedFocusAreas.join(', ') }}</strong>
            </ng-container>
            for {{ getContentTypeLabel(academicForm.get('academicLevel')?.value) }} level
          </ng-container>
          -->
          <ng-container *ngIf="activeInterface === 'document'">
            Generating response...
          </ng-container>
          <ng-container *ngIf="activeInterface === 'direct'">
            {{ processingStep || 'Generating response...' }}
          </ng-container>
        </p>
        <div class="typing-animation">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
      <div class="progress-indicator">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="processingProgress"></div>
        </div>
        <span class="progress-percentage">{{ processingProgress | number:'1.0-0' }}%</span>
      </div>
      <div class="cancel-action" *ngIf="processingProgress < 100">
        <button mat-button color="warn" (click)="cancelOperation()">Cancel</button>
      </div>
    </div>
  </div>

  <div class="content-container">
    <!-- Left Side - Input Section -->
    <div class="input-section">
      <!-- Interface Selection -->
      <div class="interface-selector">
        <mat-button-toggle-group [value]="activeInterface">
          <mat-button-toggle value="direct" (click)="switchInterface('direct')">
            <mat-icon>question_answer</mat-icon>
            <span>General Query</span>
          </mat-button-toggle>
          <mat-button-toggle value="document" (click)="switchInterface('document')">
            <mat-icon>description</mat-icon>
            <span>Document Analysis</span>
          </mat-button-toggle>
          <!-- Temporarily hiding academic content generator
          <mat-button-toggle value="academic" (click)="switchInterface('academic')">
            <mat-icon>school</mat-icon>
            <span>Academic Content</span>
          </mat-button-toggle>
          -->
        </mat-button-toggle-group>
      </div>

      <!-- Input Card -->
      <mat-card class="input-card" id="input-section">
        <mat-card-header>
          <mat-card-title>
            <ng-container *ngIf="activeInterface === 'direct'">
              <mat-icon>question-answer</mat-icon> Ask AI Anything
            </ng-container>
            <ng-container *ngIf="activeInterface === 'document'">
              <mat-icon>description</mat-icon> Document Analysis
            </ng-container>
            <ng-container *ngIf="activeInterface === 'academic'">
              <mat-icon>school</mat-icon> Academic Content Generator
            </ng-container>
          </mat-card-title>
        </mat-card-header>
        
        <mat-card-content>
          <!-- General Query Interface -->
          <ng-container *ngIf="activeInterface === 'direct'">
            <form [formGroup]="textForm" class="text-form" *ngIf="directChatHistory.length === 0">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>What would you like to know?</mat-label>
                <textarea matInput formControlName="prompt" rows="3" 
                  placeholder="Enter your question or prompt here..."
                  (focus)="setActiveSection('input-section')"></textarea>
                <mat-hint>
                  <span>Ask any question or provide a prompt for text generation</span>
                  <a class="tips-link" (click)="openGeneralQueryGuide()">
                    <mat-icon>help_outline</mat-icon> Tips for better results
                  </a>
                </mat-hint>
              </mat-form-field>
            </form>
          </ng-container>

          <!-- Document Query Interface -->
          <ng-container *ngIf="activeInterface === 'document'">
            <!-- Document Upload State -->
            <div class="document-upload" *ngIf="uploadedDocuments && uploadedDocuments.length === 0">
              <div class="upload-area" 
                   (dragover)="onDragOver($event)" 
                   (dragleave)="onDragLeave($event)"
                   (drop)="onDrop($event)"
                   [class.dragover]="isDragging">
                <mat-icon>cloud_upload</mat-icon>
                <h3>Upload Document</h3>
                <p>Drag & drop your document here or click the button below to browse files</p>
                <button mat-raised-button color="primary" (click)="fileInput.click()" class="upload-button">
                  <mat-icon>file_upload</mat-icon> Upload Document
                </button>
                <input #fileInput type="file" 
                       accept=".pdf,.doc,.docx" 
                       (change)="onFileSelected($event)"
                       style="display: none">
                <p class="supported-formats">Supported formats: PDF, DOC, DOCX (Max size: 5MB)</p>
                <p class="file-size-info">
                  <mat-icon class="info-icon">info</mat-icon>
                  For optimal performance, use smaller documents or specific document sections.
                  <br>
                  Large documents will be automatically chunked.
                </p>
              </div>
            </div>
            
            <!-- Document Selection (Simplified) -->
            <div class="document-manager" *ngIf="uploadedDocuments && uploadedDocuments.length > 0">
              <div class="document-selection-info">
                <p><mat-icon>info</mat-icon> Document ready for analysis</p>
              </div>
              
              <div class="document-list">
                <mat-selection-list [multiple]="false" (selectionChange)="onDocumentSelection($event)">
                  <mat-list-option [value]="0" [selected]="true">
                    <div class="document-item">
                      <div class="document-info">
                        <mat-icon>description</mat-icon>
                        <span class="doc-name">{{ uploadedDocuments[0].file.name }}</span>
                        <div class="document-badges" *ngIf="uploadedDocuments[0].characteristics">
                          <span class="badge" *ngIf="uploadedDocuments[0].characteristics.isScannedDocument" matTooltip="Document processed with OCR technology">
                            <span class="badge-icon ocr-icon">
                              <svg width="16" height="16">
                                <use xlink:href="assets/icons/text-module-sprites.svg#ocr-badge"></use>
                              </svg>
                            </span>
                            OCR
                          </span>
                          <span class="badge" *ngIf="uploadedDocuments[0].characteristics.containsTables" matTooltip="Tables detected and extracted">
                            <span class="badge-icon tables-icon">
                              <svg width="16" height="16">
                                <use xlink:href="assets/icons/text-module-sprites.svg#tables-badge"></use>
                              </svg>
                            </span>
                            Tables
                          </span>
                          <span class="badge" *ngIf="uploadedDocuments[0].characteristics.hasMathContent" matTooltip="Mathematical content detected">
                            <span class="badge-icon math-icon">
                              <svg width="16" height="16">
                                <use xlink:href="assets/icons/text-module-sprites.svg#math-badge"></use>
                              </svg>
                            </span>
                            Math
                          </span>
                          <span class="badge" *ngIf="uploadedDocuments[0].characteristics.hasCodeBlocks" matTooltip="Code blocks detected">
                            <span class="badge-icon code-icon">
                              <svg width="16" height="16">
                                <use xlink:href="assets/icons/text-module-sprites.svg#code-badge"></use>
                              </svg>
                            </span>
                            Code
                          </span>
                        </div>
                      </div>
                      <div class="document-actions">
                        <button mat-icon-button color="warn" (click)="removeDocument(0); $event.stopPropagation()" 
                                matTooltip="Remove Document">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </mat-list-option>
                </mat-selection-list>
              </div>
              
              <!-- Question Input - Only show when there's no chat history -->
              <form [formGroup]="documentForm" class="document-form" *ngIf="documentChatHistory.length === 0">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Ask about your documents</mat-label>
                  <textarea matInput formControlName="question" rows="3" 
                    placeholder="Ask a specific question or request an analysis"
                    (focus)="setActiveSection('input-section')"></textarea>
                  <mat-hint>
                    <span>Examples: "Summarize in 5 bullet points", "Compare the methodologies", "Create a table of key findings"</span>
                    <a class="tips-link" (click)="openDocumentAnalysisGuide()">
                      <mat-icon>help_outline</mat-icon> Tips for better results
                    </a>
                  </mat-hint>
                </mat-form-field>
              </form>

              <!-- Document Info Panel -->
              <div class="document-info-panel" *ngIf="documentChatHistory.length > 0">
                <h4><mat-icon>info</mat-icon> Document Information</h4>
                <div class="document-details">
                  <p><strong>File:</strong> {{ uploadedDocuments[0].file.name }}</p>
                  <p><strong>Size:</strong> {{ (uploadedDocuments[0].file.size / 1024).toFixed(1) }} KB</p>
                  <p><strong>Upload Date:</strong> {{ uploadedDocuments[0].dateAdded | date:'short' }}</p>
                </div>
                <div class="document-guidance" *ngIf="uploadedDocuments[0].characteristics">
                  <h5>Document Features:</h5>
                  <ul>
                    <li *ngIf="uploadedDocuments[0].characteristics.isScannedDocument">OCR processed document</li>
                    <li *ngIf="uploadedDocuments[0].characteristics.containsTables">Contains extracted tables</li>
                    <li *ngIf="uploadedDocuments[0].characteristics.hasMathContent">Contains mathematical content</li>
                    <li *ngIf="uploadedDocuments[0].characteristics.hasCodeBlocks">Contains code blocks</li>
                  </ul>
                </div>
                <div class="document-tip">
                  <p><mat-icon>lightbulb</mat-icon> Tip: Ask follow-up questions about specific sections or request different analysis types to explore your document further.</p>
                </div>
              </div>
            </div>
            
            <!-- Document Error State -->
            <div class="document-error" *ngIf="documentProcessingState === 'error'">
              <mat-icon color="warn">error</mat-icon>
              <h3>Error Processing Document</h3>
              <p>{{ processingError || 'An unknown error occurred' }}</p>
              <button mat-raised-button color="primary" (click)="resetForm()">
                Try Again
              </button>
            </div>
            
            <!-- Document Processing State -->
            <div class="document-processing" *ngIf="documentProcessingState === 'uploading' || documentProcessingState === 'analyzing'">
              <mat-icon color="primary">hourglass_empty</mat-icon>
              <h3>Processing Your Request</h3>
              <p>Generating response...</p>
              <mat-progress-bar [mode]="progressBarMode" [value]="processingProgress"></mat-progress-bar>
              <button mat-button color="warn" (click)="cancelOperation()">
                Cancel
              </button>
            </div>
          </ng-container>
          
          <!-- Academic Content Generator Interface -->
          <ng-container *ngIf="activeInterface === 'academic'">
            <form [formGroup]="academicForm" class="academic-form">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Topic</mat-label>
                <textarea matInput formControlName="topic" rows="2" 
                  placeholder="Enter the topic you want to create content for..."></textarea>
                <mat-hint>Be specific about the academic topic you need content for</mat-hint>
              </mat-form-field>
              
              <div class="academic-options">
                <div class="option-row">
                  <mat-form-field appearance="outline">
                    <mat-label>Content Type</mat-label>
                    <mat-select formControlName="contentType" (selectionChange)="onContentTypeChange()">
                      <mat-option *ngFor="let type of contentTypes" [value]="type.value">
                        {{ type.label }}
                      </mat-option>
                    </mat-select>
                    <mat-hint>Select the type of content you need</mat-hint>
                  </mat-form-field>
                  
                  <mat-form-field appearance="outline">
                    <mat-label>Academic Level</mat-label>
                    <mat-select formControlName="academicLevel">
                      <mat-option *ngFor="let level of academicLevels" [value]="level.value">
                        {{ level.label }}
                      </mat-option>
                    </mat-select>
                    <mat-hint>Choose the target academic level</mat-hint>
                  </mat-form-field>
                </div>
                
                <!-- Content Length Section -->
                <div class="option-row content-length-section">
                  <mat-form-field appearance="outline" class="content-length">
                    <mat-label>{{ getContentUnit(academicForm.get('contentType')?.value) }} Length</mat-label>
                    <input matInput type="number" formControlName="contentLength" 
                           [min]="1" 
                           [max]="10">
                    <mat-hint>
                      Enter a value between 1-10
                    </mat-hint>
                  </mat-form-field>

                  <div class="content-guide">
                    <h3>
                      <mat-icon>info</mat-icon>
                      Content Guide
                    </h3>
                    <p>The AI will structure the content appropriately based on your topic, academic level, and content type. You can add focus areas to help the AI understand what aspects to emphasize.</p>
                  </div>
                </div>
                
                <!-- Focus Areas Section -->
                <div class="focus-areas">
                  <h4>Select Focus Areas (Optional)</h4>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Focus Areas</mat-label>
                    <mat-select [formControl]="focusAreasControl" multiple (selectionChange)="onFocusAreaChange($event)">
                      <mat-option value="Key Concepts">Key Concepts</mat-option>
                      <mat-option value="Definitions">Definitions</mat-option>
                      <mat-option value="Historical Context">Historical Context</mat-option>
                      <mat-option value="Practical Applications">Practical Applications</mat-option>
                      <mat-option value="Current Trends">Current Trends</mat-option>
                      <mat-option value="Case Studies">Case Studies</mat-option>
                      <mat-option value="Examples">Examples</mat-option>
                      <mat-option value="Comparisons">Comparisons</mat-option>
                      <mat-option value="Future Developments">Future Developments</mat-option>
                      <mat-option value="Impact Analysis">Impact Analysis</mat-option>
                    </mat-select>
                    <mat-hint>Select areas you'd like the AI to focus on</mat-hint>
                  </mat-form-field>
                  
                  <div class="chips-container" *ngIf="selectedFocusAreas.length > 0">
                    <mat-chip *ngFor="let focus of selectedFocusAreas" 
                             [removable]="true"
                             (removed)="removeFocusArea(focus)"
                             color="primary"
                             selected>
                      {{focus}}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </div>
                </div>
                
                <!-- Need more complex requirements? Button -->
                <div class="redirect-section">
                  <button mat-stroked-button color="accent" (click)="switchInterface('direct')">
                    <mat-icon>question_answer</mat-icon>
                    Need more complex requirements? Go to General Query
                  </button>
                </div>
              </div>
            </form>
          </ng-container>
          
          <!-- Progress Indicator - Only visible on mobile -->
          <div class="progress-container" *ngIf="isGenerating">
            <h3>
              <mat-icon>autorenew</mat-icon>
              Processing Your Request
            </h3>
            <mat-progress-bar [mode]="progressBarMode" [value]="processingProgress"></mat-progress-bar>
            <div class="progress-label">
              <span>Generating response...</span>
              <span class="progress-percentage">{{ processingProgress | number:'1.0-0' }}%</span>
            </div>
          </div>
        </mat-card-content>
        
        <mat-card-actions>
          <button mat-button (click)="resetForm()" *ngIf="activeInterface !== 'direct' && activeInterface !== 'document'">
            Reset
          </button>
          <button mat-raised-button color="primary" 
                  (click)="generateContent()" 
                  [disabled]="isGenerating"
                  class="generate-button"
                  *ngIf="(activeInterface === 'direct' && directChatHistory.length === 0) || 
                         (activeInterface === 'document' && documentChatHistory.length === 0) || 
                         activeInterface === 'academic'">
            <mat-icon>send</mat-icon>
            <ng-container *ngIf="activeInterface === 'academic'">
              {{ isGenerating ? 'Generating...' : 'Create Content' }}
            </ng-container>
            <ng-container *ngIf="activeInterface !== 'academic'">
              {{ isGenerating ? 'Generating...' : 'Generate' }}
            </ng-container>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <!-- Right Side - Output Section -->
    <div class="output-section">
      <div class="chat-history-card" id="output-section">
        <div class="chat-history-header" (click)="setActiveSection('output-section')">
          <h3>
            <ng-container *ngIf="activeInterface === 'direct'">Chat History</ng-container>
            <ng-container *ngIf="activeInterface === 'document'">Document Analysis Results</ng-container>
            <ng-container *ngIf="activeInterface === 'academic'">Generated Academic Content</ng-container>
          </h3>
        </div>
        <mat-card-content #chatContainer>
          <!-- General Chat History -->
          <ng-container *ngIf="activeInterface === 'direct'">
            <div class="chat-message" 
                 *ngFor="let message of directChatHistory"
                 [class.user-message]="message.role === 'user'"
                 [class.ai-message]="message.role === 'assistant'">
              <div class="message-header">
                <div class="avatar" [ngClass]="message.role === 'user' ? 'user-avatar' : 'ai-avatar'">
                  <svg *ngIf="message.role === 'user'" width="36" height="36">
                    <use xlink:href="assets/icons/text-module-sprites.svg#avatar-user"></use>
                  </svg>
                  <svg *ngIf="message.role === 'assistant'" width="36" height="36">
                    <use xlink:href="assets/icons/text-module-sprites.svg#avatar-ai"></use>
                  </svg>
                </div>
                <div class="message-info">
                  <div class="sender">{{ message.role === 'user' ? 'You' : 'Assistant' }}</div>
                  <div class="timestamp">
                    {{ message.timestamp | date:'short' }}
                    <span *ngIf="message.isEdited" class="edited-badge">(edited)</span>
                  </div>
                </div>
                <div class="message-actions">
                  <button *ngIf="message.role === 'assistant'" mat-icon-button (click)="copyToClipboard(message.content)" matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                  <button *ngIf="message.role === 'user'" mat-icon-button (click)="startEditingMessage(message)" matTooltip="Edit message">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </div>
              <div class="message-content" *ngIf="editingMessageId !== message.id">
                <div [innerHTML]="message.content | safe: 'html'"></div>
              </div>
              <div class="message-edit" *ngIf="editingMessageId === message.id">
                <mat-form-field appearance="outline" class="edit-input">
                  <textarea matInput [(ngModel)]="editMessageContent" rows="3"></textarea>
                </mat-form-field>
                <div class="edit-actions">
                  <button mat-button (click)="cancelEditing()">Cancel</button>
                  <button mat-button color="primary" (click)="saveEditedMessage()">Save</button>
                </div>
              </div>
            </div>
            
            <div class="empty-state" *ngIf="directChatHistory.length === 0">
              <mat-icon>chat</mat-icon>
              <h3>No conversation yet</h3>
              <p>Ask a question to start the conversation</p>
            </div>
          </ng-container>
          
          <!-- Chat Input for General Chat -->
          <div class="chat-input-container" *ngIf="activeInterface === 'direct' && !isGenerating && directChatHistory.length > 0">
            <mat-form-field appearance="outline" class="chat-input">
              <mat-label>Type your message</mat-label>
              <textarea 
                matInput 
                [formControl]="chatInputControl" 
                placeholder="Ask a question or provide a prompt..." 
                rows="2"
                (keydown.enter)="handleEnterKey($event)"
              ></textarea>
              <mat-hint align="end">Press Enter to send, Shift+Enter for new line</mat-hint>
            </mat-form-field>
            <button 
              mat-fab 
              color="primary" 
              class="send-button" 
              [disabled]="!chatInputControl.value?.trim()" 
              (click)="sendMessage()"
              matTooltip="Send message"
            >
              <mat-icon>send</mat-icon>
            </button>
          </div>
          
          <!-- Document Chat History -->
          <ng-container *ngIf="activeInterface === 'document'">
            <div class="chat-message" 
                 *ngFor="let message of documentChatHistory"
                 [class.user-message]="message.role === 'user'"
                 [class.ai-message]="message.role === 'assistant'">
              <div class="message-header">
                <div class="avatar" [ngClass]="message.role === 'user' ? 'user-avatar' : 'ai-avatar'">
                  <svg *ngIf="message.role === 'user'" width="36" height="36">
                    <use xlink:href="assets/icons/text-module-sprites.svg#avatar-user"></use>
                  </svg>
                  <svg *ngIf="message.role === 'assistant'" width="36" height="36">
                    <use xlink:href="assets/icons/text-module-sprites.svg#avatar-ai"></use>
                  </svg>
                </div>
                <div class="message-info">
                  <div class="sender">
                    {{ message.role === 'user' ? 'You' : 'Assistant' }}
                    <span *ngIf="message.sourceDocuments?.length" class="source-docs">
                      (based on {{ message.sourceDocuments.length }} document{{ message.sourceDocuments.length > 1 ? 's' : '' }})
                    </span>
                    <span *ngIf="message.actionType" class="action-type-badge">
                      {{ getActionTypeLabel(message.actionType) }}
                    </span>
                  </div>
                  <div class="timestamp">
                    {{ message.timestamp | date:'short' }}
                    <span *ngIf="message.isEdited" class="edited-badge">(edited)</span>
                  </div>
                </div>
                <div class="message-actions">
                  <button *ngIf="message.role === 'assistant'" mat-icon-button (click)="copyToClipboard(message.content)" matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                  <button *ngIf="message.role === 'user'" mat-icon-button (click)="startEditingMessage(message)" matTooltip="Edit message">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </div>
              <div class="message-content" *ngIf="editingMessageId !== message.id">
                <div [innerHTML]="message.content | safe: 'html'"></div>
              </div>
              <div class="message-edit" *ngIf="editingMessageId === message.id">
                <mat-form-field appearance="outline" class="edit-input">
                  <textarea matInput [(ngModel)]="editMessageContent" rows="3"></textarea>
                </mat-form-field>
                <div class="edit-actions">
                  <button mat-button (click)="cancelEditing()">Cancel</button>
                  <button mat-button color="primary" (click)="saveEditedMessage()">Save</button>
                </div>
              </div>
            </div>
            
            <div class="empty-state" *ngIf="documentChatHistory.length === 0">
              <mat-icon>description</mat-icon>
              <h3>No document analysis yet</h3>
              <p>Upload documents and ask questions to get insights</p>
            </div>

            <!-- Chat Input for Document Analysis -->
            <div class="chat-input-container" *ngIf="activeInterface === 'document' && !isGenerating && uploadedDocuments && uploadedDocuments.length > 0 && documentChatHistory.length > 0">
              <mat-form-field appearance="outline" class="chat-input">
                <mat-label>Ask about your document</mat-label>
                <textarea 
                  matInput 
                  [formControl]="documentChatInputControl" 
                  placeholder="Ask a question or request an analysis..." 
                  rows="2"
                  (keydown.enter)="handleDocumentEnterKey($event)"
                ></textarea>
                <mat-hint align="end">Press Enter to send, Shift+Enter for new line</mat-hint>
              </mat-form-field>
              <button 
                mat-fab 
                color="primary" 
                class="send-button" 
                [disabled]="!documentChatInputControl.value?.trim()" 
                (click)="sendDocumentMessage()"
                matTooltip="Send message"
              >
                <mat-icon>send</mat-icon>
              </button>
            </div>
          </ng-container>
          
          <!-- Academic Content History -->
          <ng-container *ngIf="activeInterface === 'academic'">
            <div class="academic-content no-auto-scroll" *ngFor="let message of academicChatHistory">
              <div class="message-header" *ngIf="message.role === 'assistant'">
                <div class="avatar" [ngClass]="message.role === 'user' ? 'user-avatar' : 'ai-avatar'">
                  <svg *ngIf="message.role === 'user'" width="36" height="36">
                    <use xlink:href="assets/icons/text-module-sprites.svg#avatar-user"></use>
                  </svg>
                  <svg *ngIf="message.role === 'assistant'" width="36" height="36">
                    <use xlink:href="assets/icons/text-module-sprites.svg#avatar-ai"></use>
                  </svg>
                </div>
                <div class="message-info">
                  <div class="sender">
                    AI Academic Generator
                    <span class="content-type-badge" *ngIf="message.type">
                      {{ message.type | titlecase }}
                    </span>
                  </div>
                  <div class="timestamp">{{ message.timestamp | date:'short' }}</div>
                </div>
                <div class="message-actions">
                  <button mat-icon-button (click)="copyToClipboard(message.content); $event.stopPropagation();" matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
              </div>
              <div class="message-content prevent-scroll" *ngIf="message.role === 'assistant' && message.type">
                <div [innerHTML]="message.content | safe: 'html'"></div>
              </div>
              <div class="initial-guidance prevent-scroll" *ngIf="message.role === 'assistant' && !message.type" [innerHTML]="message.content | safe: 'html'">
              </div>
            </div>
            
            <div class="empty-state" *ngIf="academicChatHistory.length === 0">
              <mat-icon>school</mat-icon>
              <h3>No content generated yet</h3>
              <p>Configure your options and generate academic content</p>
            </div>

            <!-- Chat Input for Academic Content -->
            <div class="chat-input-container" *ngIf="!isGenerating">
              <mat-form-field appearance="outline" class="chat-input">
                <mat-label>Request academic content</mat-label>
                <textarea 
                  matInput 
                  [formControl]="academicChatInputControl" 
                  placeholder="Describe the academic content you need..." 
                  rows="2"
                  (keydown.enter)="handleAcademicEnterKey($event)"
                ></textarea>
                <mat-hint align="end">Press Enter to send, Shift+Enter for new line</mat-hint>
              </mat-form-field>
              <button 
                mat-fab 
                color="primary" 
                class="send-button" 
                [disabled]="!academicChatInputControl.value?.trim()" 
                (click)="sendAcademicMessage()"
                matTooltip="Send message"
              >
                <mat-icon>send</mat-icon>
              </button>
            </div>
          </ng-container>
          
          <!-- Floating Scroll Button -->
          <button mat-fab class="scroll-button" *ngIf="!isAtBottom()" (click)="manualScrollToBottom()">
            <mat-icon>arrow_downward</mat-icon>
          </button>
        </mat-card-content>
      </div>
    </div>
  </div>
</div> 